import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { conditionalRender } from '@repo/toolkit/conditional-render'
import { toFullName } from '@repo/toolkit/to-full-name'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { getAdvisors } from '../../../api/enrollments/get-advisors'
import { AssignEnrollmentToAdviserInput } from '../../../lib/types/models/enrollment/enrollment-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<AssignEnrollmentToAdviserInput> = z.object({
  id: createNumberSchema('Conseiller LEC', { isInteger: true })
})

type AssignEnrollmentFormProps = BaseFormProps<AssignEnrollmentToAdviserInput> & {
  className?: string
}

const AssignEnrollmentForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: AssignEnrollmentFormProps) => {
  const form = useForm<AssignEnrollmentToAdviserInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  const { data } = useQuery({
    queryKey: ['advisors'],
    queryFn: () => getAdvisors()
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="id"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput
                    options={data?.map((user) => ({
                      label: toFullName(user.firstName, user.lastName),
                      value: user.id
                    }))}
                    label={'Conseiller LEC'}
                    selectedOption={conditionalRender(!!field.value, {
                      label: toFullName(
                        data?.find((user) => user.id === field.value)?.firstName,
                        data?.find((user) => user.id === field.value)?.lastName
                      ),
                      value: field.value
                    })}
                    onChange={(value) => form.setValue('id', value, { shouldValidate: true })}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default AssignEnrollmentForm
